import { render, staticRenderFns } from "./CategoryGoodsShow.vue?vue&type=template&id=820c73f8&"
import script from "./CategoryGoodsShow.vue?vue&type=script&lang=js&"
export * from "./CategoryGoodsShow.vue?vue&type=script&lang=js&"
import style0 from "./CategoryGoodsShow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports